import { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FormikHelpers } from 'formik';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';

import { RootDispatch, RootState } from 'storage/store';
import { MessageTypes, UserCredentials } from 'storage/user/user.model';
import { Constant } from 'utils/consts';
import { Url } from 'utils/urls';
import { IsLoggedIn } from 'utils/user';
import ImageGrid from 'pages/account/templates/RequestPage/styled/ImageGrid';
import Illustration from 'components/Illustration/Illustration';
import { MenuVisibilityContext } from 'components/Menu/utils/menuVisibilityContext';

import IllustrationWrapper from './styled/IllustartionWrapper';
import LoginForm from './LoginForm';

export type onLoginFormSubmitType = (
  value: UserCredentials,
  actions: {
    resetForm: FormikHelpers<UserCredentials>['resetForm'];
  }
) => void;

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<RootDispatch>();
  const navigate = useNavigate();
  const onLoginFormSubmit: onLoginFormSubmitType = (value, actions) => {
    actions.resetForm({ values: { ...value, password: '' } });
    if (
      value.password.length < Constant.oneThousandTwentyFour &&
      value.login.length < Constant.seventy
    ) {
      dispatch.user.loginUser(value);
    } else {
      dispatch.user.changeUserStatus(MessageTypes.invalidPassword);
    }
  };
  const user = useSelector((state: RootState) => state.user);
  const { setVisible } = useContext(MenuVisibilityContext);

  useEffect(
    () =>
      function cleanup() {
        dispatch.user.resetUserStatus();
      },
    []
  );

  useEffect(() => {
    if (IsLoggedIn()) {
      navigate(Url.dashboard);
    }
    return window.scrollTo({ top: 0 });
  }, [user]);

  useEffect(() => {
    setVisible!(false);
  }, []);

  return (
    <>
      <Helmet>
        <title>{t('ROUTING_LOGIN_TITLE')}</title>
        <meta name="description" content={t('ROUTING_LOGIN_DESCRIPTION')} />
      </Helmet>
      <Box flexGrow={1}>
        <Grid container sx={{ height: '100%' }}>
          <ImageGrid size={{ lg: 5, xl: 5 }}>
            <IllustrationWrapper disableGutters>
              <Illustration component="login" />
            </IllustrationWrapper>
          </ImageGrid>
          <LoginForm onLoginFormSubmit={onLoginFormSubmit} />
        </Grid>
      </Box>
    </>
  );
};

export default Login;
